/* THRONE ADVENT · Iron Realm theme — interactions (gallery, variants, quantity, cart drawer, sticky ATC, mobile menu, scroll reveal, tilt) */
(function () {
  'use strict';
  var T = window.theme || {};
  var S = T.strings || {};

  function formatMoney(cents) {
    var fmt = T.moneyFormat || '{{amount}}';
    function withDelims(num, precision, thousands, decimal) {
      num = (num / 100).toFixed(precision);
      var parts = num.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return withDelims(cents, 2, ',', '.');
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        case 'amount_with_space_separator': return withDelims(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return withDelims(cents, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return withDelims(cents, 2, "'", '.');
        default: return withDelims(cents, 2, ',', '.');
      }
    });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    var menu = document.querySelector('[data-mobile-menu]');
    if (!menu) return;
    document.querySelectorAll('[data-menu-open]').forEach(function (b) {
      b.addEventListener('click', function () { menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); document.body.classList.add('lock-scroll'); });
    });
    menu.querySelectorAll('[data-menu-close]').forEach(function (b) {
      b.addEventListener('click', function () { menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); document.body.classList.remove('lock-scroll'); });
    });
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var gallery = root.querySelector('[data-gallery]');
    if (!gallery) return;
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
    var current = 0;

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
      if (thumbs[i]) thumbs[i].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
    function goTo(i) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActive(i);
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-thumb'), 10)); }); });
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    var timer;
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) setActive(i);
      }, 80);
    }, { passive: true });

    gallery.goToMedia = function (mediaId) {
      slides.forEach(function (s, idx) { if (String(s.getAttribute('data-media-id')) === String(mediaId)) goTo(idx); });
    };
  }

  /* ---------- Variants ---------- */
  function initVariants(root) {
    var jsonEl = root.querySelector('[data-variants-json]');
    if (!jsonEl) return;
    var variants = JSON.parse(jsonEl.textContent);
    var inputs = root.querySelectorAll('[data-option-index]');
    var idInput = root.querySelector('[data-variant-id]');
    var atc = root.querySelector('[data-atc]');
    var atcText = root.querySelector('[data-atc-text]');
    var atcLabel = atcText ? atcText.textContent.trim() : S.addToCart;
    var gallery = root.querySelector('[data-gallery]');

    function selected() {
      var opts = [];
      inputs.forEach(function (i) { if (i.checked) opts[parseInt(i.getAttribute('data-option-index'), 10)] = i.value; });
      return opts;
    }
    function update() {
      var opts = selected();
      opts.forEach(function (v, idx) {
        var label = root.querySelector('[data-option-label="' + idx + '"]');
        if (label) label.textContent = v;
      });
      var v = variants.find(function (vr) { return vr.options.every(function (o, idx) { return o === opts[idx]; }); });
      if (!v) return;
      if (idInput) idInput.value = v.id;
      var priceEl = root.querySelector('[data-price]');
      var cmpEl = root.querySelector('[data-compare-price]');
      var badge = root.querySelector('[data-save-badge]');
      var wrapper = root.querySelector('[data-price-wrapper]');
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      if (wrapper) wrapper.classList.toggle('price--sale', !!sale);
      if (cmpEl) { cmpEl.hidden = !sale; if (sale) cmpEl.textContent = formatMoney(v.compare_at_price); }
      if (badge) {
        badge.hidden = !sale;
        if (sale) {
          var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
          badge.textContent = badge.textContent.replace(/\d+%/, pct + '%');
          if (!/\d+%/.test(badge.textContent)) badge.textContent = '-' + pct + '%';
        }
      }
      var sticky = document.querySelector('[data-sticky-price]');
      if (sticky) sticky.textContent = formatMoney(v.price);
      if (atc) {
        atc.disabled = !v.available;
        if (atcText) atcText.textContent = v.available ? atcLabel : S.soldOut;
      }
      if (v.featured_media && gallery && gallery.goToMedia) gallery.goToMedia(v.featured_media.id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    inputs.forEach(function (i) { i.addEventListener('change', update); });
  }

  /* ---------- Quantity steppers ---------- */
  function bindQty(scope) {
    scope.querySelectorAll('[data-qty]').forEach(function (q) {
      if (q.dataset.bound) return;
      q.dataset.bound = '1';
      var input = q.querySelector('input');
      q.querySelector('[data-qty-minus]').addEventListener('click', function () {
        var min = parseInt(input.min || '1', 10);
        input.value = Math.max(min, (parseInt(input.value, 10) || 1) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      q.querySelector('[data-qty-plus]').addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 0) + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = document.getElementById('CartDrawer');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lock-scroll');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lock-scroll');
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    if (!drawer) return;
    var label = drawer.querySelector('[data-cart-count-label]');
    if (label) label.textContent = '(' + cart.item_count + ')';
    var list = drawer.querySelector('[data-cart-items]');
    var sub = drawer.querySelector('[data-cart-subtotal]');
    if (sub) sub.textContent = formatMoney(cart.total_price);

    if (!cart.items.length) {
      list.innerHTML = '<p class="cart-drawer__empty">' + escapeHtml(S.empty) + '</p>';
    } else {
      list.innerHTML = cart.items.map(function (item, idx) {
        var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
        var variant = item.product_has_only_default_variant ? '' : '<div class="drawer-line__variant">' + escapeHtml(item.variant_title) + '</div>';
        var compare = item.original_line_price > item.final_line_price ? '<span class="drawer-line__compare">' + formatMoney(item.original_line_price) + '</span>' : '';
        return '<div class="drawer-line">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy" width="80" height="80">' : '<span></span>') +
          '<div><a class="drawer-line__title" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' + variant +
          '<div class="qty" data-qty><button type="button" class="qty__btn" data-qty-minus aria-label="-">&minus;</button>' +
          '<input class="qty__input" type="number" min="0" value="' + item.quantity + '" data-line="' + (idx + 1) + '" aria-label="qty">' +
          '<button type="button" class="qty__btn" data-qty-plus aria-label="+">+</button></div>' +
          '<div><button type="button" class="link-underline" data-remove-line="' + (idx + 1) + '">' + escapeHtml(S.remove) + '</button></div></div>' +
          '<div class="drawer-line__price">' + formatMoney(item.final_line_price) + compare + '</div>' +
          '</div>';
      }).join('');
      bindQty(list);
      list.querySelectorAll('input[data-line]').forEach(function (inp) {
        inp.addEventListener('change', function () { changeLine(parseInt(inp.getAttribute('data-line'), 10), parseInt(inp.value, 10) || 0); });
      });
      list.querySelectorAll('[data-remove-line]').forEach(function (b) {
        b.addEventListener('click', function () { changeLine(parseInt(b.getAttribute('data-remove-line'), 10), 0); });
      });
    }

    var threshold = T.freeShippingThreshold || 0;
    var wrap = drawer.querySelector('[data-free-shipping]');
    if (wrap) {
      if (threshold > 0 && cart.item_count > 0) {
        wrap.hidden = false;
        var remaining = threshold - cart.total_price;
        var pct = Math.min(100, Math.round(cart.total_price * 100 / threshold));
        drawer.querySelector('[data-free-shipping-bar]').style.width = pct + '%';
        drawer.querySelector('[data-free-shipping-text]').textContent = remaining <= 0 ? S.freeShippingReached : S.freeShippingAway.replace('{{ amount }}', formatMoney(remaining));
      } else {
        wrap.hidden = true;
      }
    }
  }

  function fetchCart() {
    return fetch((T.routes.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function changeLine(line, quantity) {
    return fetch((T.routes.cart_change_url || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function initForms() {
    document.querySelectorAll('form[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var root = form.closest('[data-product-section]') || document;
        var upsells = Array.prototype.slice.call(root.querySelectorAll('[data-upsell]:checked'));
        var useDrawer = T.cartType === 'drawer' && !!drawer;
        if (!useDrawer && upsells.length === 0) return;
        e.preventDefault();
        var btn = form.querySelector('[data-atc]');
        var txt = btn ? btn.querySelector('[data-atc-text]') : null;
        var original = txt ? txt.textContent : '';
        var err = form.querySelector('[data-form-error]');
        if (err) err.hidden = true;
        if (btn) btn.disabled = true;
        if (txt) txt.textContent = S.adding;
        var request;
        if (upsells.length) {
          var fd = new FormData(form);
          var items = [{ id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity'), 10) || 1 }];
          upsells.forEach(function (u) { items.push({ id: parseInt(u.value, 10), quantity: 1 }); });
          request = { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) };
        } else {
          request = { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) };
        }
        fetch((T.routes.cart_add_url || '/cart/add') + '.js', request).then(function (r) {
          return r.json().then(function (data) { if (!r.ok) throw data; return data; });
        }).then(function () {
          return fetchCart();
        }).then(function (cart) {
          if (!useDrawer) { window.location.href = T.routes.cart_url || '/cart'; return; }
          renderCart(cart);
          openDrawer();
        }).catch(function (data) {
          if (err) { err.textContent = (data && (data.description || data.message)) || S.error; err.hidden = false; }
        }).finally(function () {
          if (btn) btn.disabled = false;
          if (txt) txt.textContent = original;
        });
      });
    });

    document.querySelectorAll('[data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (T.cartType !== 'drawer' || !drawer || document.body.classList.contains('template-cart')) return;
        e.preventDefault();
        fetchCart().then(renderCart);
        openDrawer();
      });
    });
    if (drawer) {
      drawer.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
      fetchCart().then(renderCart).catch(function () {});
    }
  }

  /* ---------- Sticky ATC ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-sticky-atc]');
    var buy = document.querySelector('.product__buy');
    if (!bar || !buy || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }).observe(buy);
  }


  /* ---------- Scroll reveal ---------- */
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('[data-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || document.body.classList.contains('no-reveal')) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el, i) {
      if (!el.style.transitionDelay && el.hasAttribute('data-reveal-stagger')) el.style.transitionDelay = (i % 6) * 90 + 'ms';
      io.observe(el);
    });
  }

  /* ---------- Subtle 3D tilt (desktop pointer only) ---------- */
  function initTilt(scope) {
    if (!window.matchMedia || !window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    (scope || document).querySelectorAll('[data-tilt]').forEach(function (el) {
      if (el.dataset.tiltBound) return;
      el.dataset.tiltBound = '1';
      var max = parseFloat(el.getAttribute('data-tilt')) || 8;
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(900px) rotateY(' + (x * max) + 'deg) rotateX(' + (-y * max) + 'deg)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }

  function initProductSections() {
    document.querySelectorAll('[data-product-section]').forEach(function (s) {
      initGallery(s);
      initVariants(s);
    });
    bindQty(document);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenu();
    initProductSections();
    initForms();
    initSticky();
    initReveal();
    initTilt();
  });

  document.addEventListener('shopify:section:load', function (e) {
    initProductSections();
    initForms();
    initSticky();
    initReveal(e.target);
    initTilt(e.target);
  });
})();
